import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Helper to get current language from localStorage
const getLanguage = () => localStorage.getItem('preferred_language') || 'en';

// Axios instance with default config
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Destinations API
export const destinationsAPI = {
  getAll: async (params = {}) => {
    const response = await apiClient.get('/destinations', { 
      params: { ...params, lang: getLanguage() } 
    });
    return response.data.destinations;
  },
  getById: async (id) => {
    const response = await apiClient.get(`/destinations/${id}`, {
      params: { lang: getLanguage() }
    });
    return response.data;
  },
  getByRegion: async () => {
    const response = await apiClient.get('/destinations/by-region', {
      params: { lang: getLanguage() }
    });
    return response.data.regions;
  },
};

// Trips API
export const tripsAPI = {
  getAll: async (params = {}) => {
    const response = await apiClient.get('/trips', { 
      params: { ...params, lang: getLanguage() } 
    });
    return response.data.trips;
  },
  getById: async (id) => {
    const response = await apiClient.get(`/packages/${id}`, {
      params: { lang: getLanguage() }
    });
    return response.data;
  },
  getMatrix: async () => {
    const response = await apiClient.get('/trips/matrix', {
      params: { lang: getLanguage() }
    });
    return response.data;
  },
  getFeatured: async (limit = 6) => {
    const response = await apiClient.get('/trips', { 
      params: { featured: true, limit, lang: getLanguage() } 
    });
    return response.data.trips;
  },
  getByDestination: async (destinationId) => {
    const response = await apiClient.get('/trips', { 
      params: { destination_id: destinationId, lang: getLanguage() } 
    });
    return response.data.trips;
  },
};

// Packages API
export const packagesAPI = {
  getAll: async (params = {}) => {
    const response = await apiClient.get('/packages', { 
      params: { ...params, lang: getLanguage() } 
    });
    return response.data.packages;
  },
  getById: async (id) => {
    const response = await apiClient.get(`/packages/${id}`, {
      params: { lang: getLanguage() }
    });
    return response.data;
  },
  getFeatured: async (limit = 3) => {
    const response = await apiClient.get('/packages', { 
      params: { featured: true, limit, lang: getLanguage() } 
    });
    return response.data.packages;
  },
};

// Consultations API
export const consultationsAPI = {
  create: async (data) => {
    const response = await apiClient.post('/consultations', data);
    return response.data;
  },
};

// Testimonials API
export const testimonialsAPI = {
  getAll: async (params = {}) => {
    const response = await apiClient.get('/testimonials', { 
      params: { ...params, lang: getLanguage() } 
    });
    return response.data.testimonials;
  },
  getFeatured: async () => {
    const response = await apiClient.get('/testimonials', { 
      params: { featured: true, lang: getLanguage() } 
    });
    return response.data.testimonials;
  },
};

// Newsletter API
export const newsletterAPI = {
  subscribe: async (data) => {
    const response = await apiClient.post('/newsletter/subscribe', data);
    return response.data;
  },
  unsubscribe: async (email) => {
    const response = await apiClient.post('/newsletter/unsubscribe', { email });
    return response.data;
  },
};

export default apiClient;
